import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import logo_mynextID from "../../img/logo_mynextID.svg";
import { navItemsNoAuth } from "./NavItems";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faX } from "@fortawesome/free-solid-svg-icons";

let pathname = window.location.pathname;
if (pathname === "" || pathname === "/") {
  pathname = "/";
}

interface HeaderNoAuthProps {
  onCurrent?: (path: string) => void;
}

function HeaderAuth(props: HeaderNoAuthProps) {
  const [current, setCurrent] = useState("." + pathname);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="site-header">
        <img
          id="logo-basic"
          src={logo_mynextID}
          alt="logo"
          className="logo clickable"
          onClick={() => {
            setCurrent("./");
            navigate("/");
          }}
        />

        <nav id="basic-nav" className="site-navigation profile-dropdown-menu">
          <ul className="nav topnav profile-dropdown-nav-menu" id="myTopnav">
            {navItemsNoAuth.map((item) => {
              return (
                <li
                  key={item.id}
                  className={
                    item.path === current ? "nav-item active" : "nav-item"
                  }
                >
                  <Link
                    to={item.path}
                    onClick={() => {
                      setCurrent(item.path);
                      if (props.onCurrent) {
                        props.onCurrent(item.path);
                      }
                    }}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </header>
    </>
  );
}

export default HeaderAuth;
